<template>
  <div class="row">
    <div class="col-xs-12">
      <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
        <font-awesome-icon :icon="'arrow-left'"/>
        Voltar
      </button>
      <h1 class="page-header">{{ label }} Subgrupo</h1>
      <div class="row">
        <div class="col-xs-12">
          <form role="form" @submit.prevent="save()">
            <fieldset>
              <!-- Select -->
              <div class="col-xs-12 col-sm-4">
                <div
                  :class="[
                    'form-group',
                    { 'has-error': errors.has('grupo_codigo') }
                  ]"
                >
                  <label class="control-label custom-font">Grupo</label>
                  <div class="custom-select">
                    <select
                      ref="grupo_codigo"
                      class="form-control select-selected"
                      name="grupo_codigo"
                      v-model="model.grupo_codigo"
                      v-validate="'required'"
                    >
                      <option
                        v-for="p in grupos"
                        :key="p.codigo"
                        :value="p.codigo"
                      >
                        {{ p.nome }}
                      </option>
                    </select>
                  </div>
                  <small
                    v-if="errors.has('grupo_codigo')"
                    data-bv-validator="notempty"
                    data-bv-validator-for="grupo_codigo"
                    class="help-block"
                    style=""
                    >Preenchimento obrigatório!</small
                  >
                </div>
              </div>
              <!-- Text input-->
              <div class="col-xs-12 col-sm-6">
                <div
                  :class="['form-group', { 'has-error': errors.has('nome') }]"
                >
                  <label
                    :class="[
                      'control-label',
                      'custom-font',
                      { 'is-danger': errors.has('nome') }
                    ]"
                    >Nome do Subgrupo</label
                  >
                  <div class="inputGroupContainer">
                    <div class="input-group">
                      <span class="input-group-addon"
                        ><font-awesome-icon
                          :icon="'id-card'"
                          :class="[{ 'is-danger': errors.has('nome') }]"
                      /></span>
                      <input
                        ref="nome"
                        v-model="model.nome"
                        name="nome"
                        v-validate="'required'"
                        maxlength="50"
                        :class="[
                          'form-control',
                          { 'is-danger': errors.has('nome') }
                        ]"
                        placeholder="Nome"
                        type="text"
                      />
                      <div
                        :class="[
                          'input-group-addon custom-input-group-addon-count',
                          { 'is-danger': errors.has('nome') }
                        ]"
                        v-text="50 - model.nome.length"
                      ></div>
                    </div>
                    <small
                      v-if="errors.has('nome')"
                      data-bv-validator="notEmpty"
                      data-bv-validator-for="nome"
                      class="help-block"
                      style=""
                    >
                      <font-awesome-icon :icon="'exclamation-triangle'" />
                      {{ errors.first('nome') }}
                    </small>
                  </div>
                </div>
              </div>

              <!-- Button -->
              <div class="col-xs-12 col-sm-2">
                <div class="form-group" style="margin-top: 23px;">
                  <button
                    class="btn btn-default"
                    :disabled="carregando"
                  >
                    <font-awesome-icon
                      v-if="carregando"
                      :icon="'spinner'"
                      spin
                    />
                    <font-awesome-icon v-else :icon="'save'" />
                    Salvar
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-id-card {
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.custom-input-group-addon-count.is-danger {
  color: #990000;
}

.fa-id-card.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import { request } from '@/request'

export default {
  name: 'mp-subgrupo-save',
  data() {
    return {
      label: 'Adicionar',
      apiUrl: 'material/subgrupo',
      grupos: [],
      model: {
        nome: ''
      },
      carregando: false
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    this.loadGrupos()
  },
  methods: {
    async loadGrupos() {
      const response = await request.get('materiais/listar-grupos')
      this.grupos = response.data
      this.model.grupo_codigo = this.grupos[0].codigo
    },
    toogleLoading() {
      this.carregando = !this.carregando
    },
    saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.')
      this.$router.push({ name: 'user_material_subgrupo' })
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
      console.log(result.response)
      this.toogleLoading()
    },
    save() {
      this.toogleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        request
          .post(this.apiUrl, this.model)
          .then(this.saveSuccess)
          .catch(this.saveFail)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/materiais-padronizados/subgrupo/Save.vue